'use client';

import { OverlayDeck } from '@/components/patterns/OverlayDeck';
import { GA_OVERLAY_SET } from '@/constants/analytics';

import styles from './ButtonGrid.module.css';
import { ResponseActionCard } from './ResponseActionCard';

import type { OverlayLabels } from '@/components/patterns/Overlay';
import type { ResolvedOverlayEntry } from '@/content/data/overlay-entries';

type ButtonGridProps = {
  heading: string;
  entries: readonly ResolvedOverlayEntry[];
  labels: OverlayLabels;
};

export function ButtonGrid({ heading, entries, labels }: ButtonGridProps) {
  return (
    <div className={styles.root}>
      <OverlayDeck
        entries={entries}
        labels={labels}
        overlaySet={GA_OVERLAY_SET.actions}
        renderTriggers={(triggers) => (
          <div
            className={styles.grid}
            role="group"
            aria-label={heading}
            data-lenis-prevent=""
          >
            {triggers}
          </div>
        )}
        renderTrigger={(entry, { triggerProps, isActive }) => (
          <ResponseActionCard
            entry={entry}
            triggerProps={triggerProps}
            isActive={isActive}
          />
        )}
      />
    </div>
  );
}
